import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="section-y bg-muted/40 relative">
      <div className="max-page container-px">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16 lg:mb-24">
          <Reveal className="lg:col-span-7">
            <Overline>Capabilities</Overline>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-foreground">
              Nine specialised verticals,<br />
              <em className="not-italic text-primary/80">one accountable team.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Browse the categories below. Each is run by a category lead with
              direct supplier relationships and deep market insight — so you
              receive expert sourcing, not generic order-taking.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.08}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${i}`}
                className="group relative block w-full text-left rounded-2xl overflow-hidden border border-border bg-card transition-all duration-700 hover:-translate-y-1 hover:shadow-[0_24px_60px_-25px_rgba(30,58,138,0.25)]"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground/85 via-foreground/30 to-transparent" />
                  <div className="absolute top-5 left-5 text-background/90 text-xs tracking-[0.3em] uppercase">
                    {s.n} / 09
                  </div>
                  <div className="absolute top-5 right-5 w-9 h-9 rounded-full bg-background/15 backdrop-blur-md flex items-center justify-center text-background border border-background/30 transition-transform duration-500 group-hover:rotate-45">
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                  <div className="absolute bottom-0 inset-x-0 p-6 sm:p-7 text-background">
                    <h3 className="font-display text-2xl sm:text-[1.7rem] leading-tight">
                      {s.title}
                    </h3>
                    <div className="mt-3 overflow-hidden">
                      <p className="text-sm text-background/80 leading-relaxed max-h-0 group-hover:max-h-32 transition-all duration-700 ease-out">
                        {s.short}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
